export default __webpack_public_path__ + "static/media/tag_free-parking.bdfceb4c.svg";